import { cloneElement } from 'react';
import { jsx } from '@emotion/react';

export const getDisplayName = (Component): string =>
  Component.displayName || Component.name || 'Component';

export const objectValues = <T extends Object>(obj: T) =>
  Object.keys(obj).map((k) => obj[k]);

export const emotionClone = (child, props) => {
  if (child.props.css) {
    return cloneElement(child, {
      ...props,
      css: (theme) => [
        child.props.css instanceof Function
          ? child.props.css(theme)
          : child.props.css,
        props.css,
      ],
    });
  }

  return jsx(child.type, {
    key: child.key,
    ...child.props,
    ...props,
  });
};
